export const PREMIUMIZATION = 'premiumization';
export const REGISTRATION_DIAL_INS = 'registrationDialInsEnabled';
export const EVERCALL_BULK_EDIT = 'evercallBulkEdit';
export const EVERCALL_SAVE_AND_NOTIFY_INLINE_EDIT = 'evercallSaveAndNotifyInlineEdit';

export const EUROPEAN_MARKET_OPEN_ACCESS = 'europeanMarketOpenAccess';

export const featureToggle = {
  [PREMIUMIZATION]: {
    cookieName: PREMIUMIZATION,
  },
  [REGISTRATION_DIAL_INS]: {
    cookieName: REGISTRATION_DIAL_INS,
  },
  [EVERCALL_BULK_EDIT]: {
    cookieName: EVERCALL_BULK_EDIT,
  },
  [EUROPEAN_MARKET_OPEN_ACCESS]: {
    cookieName: EUROPEAN_MARKET_OPEN_ACCESS,
  },
  [EVERCALL_SAVE_AND_NOTIFY_INLINE_EDIT]: {
    cookieName: EVERCALL_SAVE_AND_NOTIFY_INLINE_EDIT,
  },
};
